import { RiGroupFill, Stack, Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'component-library';
import { useTranslation } from 'react-i18next';

import { DraftPlotGroup } from '@/api/rest/resources/types/plot';
import { getDisplayNumber } from '@/hooks/useDisplayNumber';
import { squareMetersToHectares } from '@/utils/plot';

type DraftPlotGroupsTableProps = {
  groups: DraftPlotGroup[];
  onSelect: (id: string) => void;
};

export const DraftPlotGroupsTable = ({ groups, onSelect }: DraftPlotGroupsTableProps) => {
  const { t } = useTranslation();

  if (!groups.length) return null;

  return (
    <div className='rounded-3xl bg-white-100'>
      <Table data-testid='draft-plot-groups-table'>
        <TableHeader>
          <TableRow>
            <TableHead>{t('shared.uploadPlots.review.groupColumn')}</TableHead>
            <TableHead>{t('shared.uploadPlots.review.plotsColumn')}</TableHead>
            <TableHead>{t('shared.uploadPlots.review.sizeColumn')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {groups.map((group) => (
            <TableRow key={group.id} className='cursor-pointer' onClick={() => onSelect(group.id)}>
              <TableCell>
                <Stack direction='row' centerMain spacing={3}>
                  <RiGroupFill size={16} className='shrink-0 text-primary-100' />
                  <span className='max-w-full truncate'>{group.name}</span>
                </Stack>
              </TableCell>
              <TableCell>
                <span className='whitespace-nowrap'>{group.total_plots}</span>
              </TableCell>
              <TableCell>
                <span className='whitespace-nowrap'>
                  {getDisplayNumber(squareMetersToHectares(group.total_area), window.navigator.language)} ha
                </span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
